import "./Header.scss";

import React, { useState, useEffect, Fragment } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import logo from "../../assets/logo.png";
import instaIcon from "../../assets/icons/Instagram.svg";
import phoneIcon from "../../assets/icons/Phone.svg";
import telIcon from "../../assets/icons/Telegram.svg";
import menu from "../../assets/icons/bx-menu.svg";
import Sidebar from "../Sidebar";

const Header = ({ exchangeData }) => {
  // State for present time
  // states
  const [showSidebar, setShowSidebar] = useState(false);

  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <Fragment>
      <header className="header">
        <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <div className="logo">
          <Link to="/">
            <img className="main-logo" src={logo} alt="logo" />
          </Link>
        </div>
        <nav className="nav">
          <ul>
            <li
              className={`forms menu-item ${
                location.pathname === "/" ? "isActive" : ""
              }`}
            >
              <NavLink to="/" className="link">
                <span>خانه</span>
              </NavLink>
            </li>
            <li
              className={`gallery menu-item ${
                location.pathname === "/about-us" ? "isActive" : ""
              }`}
            >
              <NavLink to="/about-us" className="link">
                <span>درباره ما</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/contact-us" ? "isActive" : ""
              }`}
            >
              <NavLink to="/contact-us" className="link">
                <span>تماس با ما</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/gallery" ? "isActive" : ""
              }`}
            >
              <NavLink to="/gallery" className="link">
                <span>گالری</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/prices" ? "isActive" : ""
              }`}
            >
              <NavLink to="/prices" className="link">
                <span>نرخ جهانی</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/archive" ? "isActive" : ""
              }`}
            >
              <NavLink to="/archive" className="link">
                <span>آرشیو</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/terms-conditions" ? "isActive" : ""
              }`}
            >
              <NavLink to="/terms-conditions" className="link">
                <span>قوانین و مقررات</span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="socials">
          <a       target="_blank"  className="icon" href={`https://t.me/${exchangeData ? exchangeData.telegram : ""}`}>
            <img className="circle-social" alt="social" src={telIcon} />
          </a>
          <a target="_blank"  className="icon" href={`https://www.instagram.com/p/DaHxzN1DV1M/`}>
            <img className="circle-social" alt="social" src={instaIcon} />
          </a>
          <a className="phone gradient-btn-1" href={`tel:021-54583`}>
            <img alt="social" src={phoneIcon} />
            <span>021-54583</span>
          </a>
        </div>
      </header>
    </Fragment>
  );
};

export default Header;
